const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.INVITATIONS)

export const apiEmployeeInvites = {
	getEmployeeInvites: async (
		role: EEmployeeRole[] | undefined,
		search: string | undefined,
		page = 1,
		perPage = 25,
	) => {
		const { data, meta } = await apiCommon<IEmployeeInvitation[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { role: role?.join(','), search }),
		})
		return { data: data.map(d => EmployeeInvitation(d)), meta }
	},
	sendInviteEmployee: async (
		email: string,
		role: EEmployeeRole,
		location_ids: number[],
		facility_ids: string[],
		position: string | null,
	) => {
		const { data } = await apiCommon<IEmployeeInvitation>(`${groupPrefix}`, {
			method: 'POST',
			body: { email, role, location_ids, facility_ids, position },
		})
		return EmployeeInvitation(data)
	},
	resendEmployeeInvite: async (invitationID: number) => {
		const { data } = await apiCommon<IEmployeeInvitation>(`${groupPrefix}/${invitationID}/resend`, {
			method: 'POST',
		})
		return EmployeeInvitation(data)
	},
	deleteEmployeeInvite: async (invitationID: number) =>
		await apiCommon<string>(`${groupPrefix}/${invitationID}`, {
			method: 'DELETE',
		}),

	updateEmployeeInvite: async (
		invitationID: number,
		role: EEmployeeRole,
		position: string | null | undefined,
		location_ids: number[],
		facility_ids: string[],
	) => {
		const { data } = await apiCommon<IEmployeeInvitation>(`${groupPrefix}/${invitationID}`, {
			method: 'PUT',
			body: { role, position, location_ids, facility_ids },
		})
		return EmployeeInvitation(data)
	},
}
